export default "__VITE_ASSET__77e7c22f__"